import React, { useState, useEffect } from "react";
import "./BodyMeasurements.css";
import BackBtn from "../../Components/BackBtn/BackBtn";
import { useNavigate, useLocation } from "react-router-dom";
import sizesData from "../MonthlyReport/sizesData";
import SizeSelector from "../../Components/SizeSelector/SizeSelector";
import { useAuth } from "../../AuthContext";
import Axios from "axios";
import Alert from "../../Components/Alert/Alert";
import { useBaseUrl } from "../../ApiContext";

export default function BodyMeasurements() {
  const location = useLocation();
  const navigate = useNavigate();
  const { userToken } = useAuth();
  const baseUrl = useBaseUrl();
  const { selectedImages, formId, planType } = location.state || {};
  const [bodyMeasurements, setBodyMeasurements] = useState(
    sizesData.reduce((acc, item) => {
      acc[item.label] = "0.0";
      return acc;
    }, {})
  );
  const [postObject, setPostObject] = useState({
    ...selectedImages,
    ...bodyMeasurements,
  });
  const [showAlert, setShowAlert] = useState(false);
  const [alertText, setAlertText] = useState("");

  const handleSizeChange = (label, cm, mm) => {
    setBodyMeasurements((prevMeasurements) => {
      return {
        ...prevMeasurements,
        [label]: `${cm}.${mm}`,
      };
    });
  };

  useEffect(() => {
    setPostObject((prevPostObject) => ({
      ...prevPostObject,
      ...bodyMeasurements,
    }));
  }, [bodyMeasurements]);

  const handleCompleteBtn = async () => {
    setShowAlert(true);
    setTimeout(() => {
      setShowAlert(false);
    }, 2000);
    setAlertText("در حال ارسال فرم...");
    try {
      const response = await Axios.post(
        `${baseUrl}/report/${planType}_plan/${formId}/first`,
        postObject,
        {
          headers: {
            Authorization: `Token ${userToken}`,
          },
        }
      );
      if (response.status === 200) {
        navigate("/completeForm");
      }
    } catch (error) {
      console.log("Error during posting user body info", error);
    }
  };

  return (
    <div className="gymBg bgContainer">
      <div className="blurOverlay">
        <div className="pageWrapper uploadUserImg">
          <div className="pageHeader centeredFlex">
            <BackBtn />
          </div>
          <div className="pageTitle horizontalBorder">
            ارزیابی پزشکی{" "}
            <img
              src="/images/report.svg"
              alt="report icon"
              className="reportIcon"
            />
          </div>
          <div className="bodyMeasurementsContent centeredFlex scroll">
            {sizesData.map((item) => (
              <div
                key={item.id}
                className={`${item.class} horizontalBorder centeredFlex`}
              >
                <h3 className="monthlyReportTitle">{item.title}</h3>
                <SizeSelector
                  label={item.label}
                  onSizeChange={(label, cm, mm) =>
                    handleSizeChange(item.label, cm, mm)
                  }
                />
              </div>
            ))}
            <div className="bodyMeasurementsBtn">
              <button
                className="nextQuestion"
                style={{ marginTop: "2rem" }}
                onClick={handleCompleteBtn}
              >
                تمام
              </button>
            </div>
          </div>
          <Alert showAlert={showAlert} alertText={alertText} />
        </div>
      </div>
    </div>
  );
}
